import { DEFAULT_COLORS } from "../../colors";
import { createIframe } from "../messageTypes/iframe";
import { createText } from "../messageTypes/text";
import { createVideo } from "../messageTypes/video";
import jumpingDots from "./jumpingDots";

//CREATE THE HTML DIVS
const createMessageHtml = (text) => {

    const { iframe, video } = text;

    const { messagesFontColor, messagesBackgroundColor } = DEFAULT_COLORS;

    const div = document.createElement("div");
    div.classList.add('chatheadMessage');
    div.style.color = messagesFontColor;
    div.style.backgroundColor = messagesBackgroundColor;

    const contentDiv = document.createElement("div");
    contentDiv.classList.add('chatheadMessageContent');

    //S8 IFRAME
    if (iframe) {

        createIframe({ div, contentDiv })

    } else if (video) {

        //VIDEO
        createVideo({ div, contentDiv })

    } else {

        //NORMAL TEXT
        createText({ contentDiv, text })

    }

    //ADD THE JUMPING DOTS
    div.append(jumpingDots())

    //ADD THE CONTENT, VIDEO OR TEXT
    div.append(contentDiv)

    return div

}

export default createMessageHtml
